import api from './api'

export const logoService = {
  /**
   * Fetches the active system logo
   * @returns {Promise<Object>} The active logo
   */
  async getActiveLogo() {
    try {
      const response = await api.get('/settings/logos/active')
      return response.data
    } catch (error) {
      console.error('Error fetching active logo:', error)
      throw error
    }
  }
}

export default logoService
